// src/App.js
import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import './shared/scss/_styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import WhatsAppButton from './components/common/WhatsAppButton';
import { Layout } from './Layout/Layout';
import LoadingSpinner from './components/common/LoadingSpinner';

import TawkWidget from './components/common/TawkWidget';
import GoogleAnalytics from './components/common/GoogleAnalytics';

const Shop = React.lazy(() => import('./components/pages/Shop'));
const Login = React.lazy(() => import('./components/pages/Auth/Login'));
const Register = React.lazy(() => import('./components/pages/Auth/Register'));
const Forgotpassword = React.lazy(() => import('./components/pages/Auth/Forgotpassword'));
const Resetpassword = React.lazy(() => import('./components/pages/Auth/Resetpassword'));
const Contact = React.lazy(() => import('./components/pages/Contact'));
const About = React.lazy(() => import('./components/pages/About'));
const Catalog = React.lazy(() => import('./components/pages/Catalog'));
const Myaccount = React.lazy(() => import('./components/pages/Myaccount'));
const Changepassword = React.lazy(() => import('./components/pages/Changepassword'));
const Termofuse = React.lazy(() => import('./components/pages/Termofuse'));
const Termofdelivary = React.lazy(() => import('./components/pages/Termofdelivary'));
const Privacypolicy = React.lazy(() => import('./components/pages/Privacypolicy'));
const Returnrefund = React.lazy(() => import('./components/pages/Returnrefund'));
const Product = React.lazy(() => import('./components/pages/Product'));
const Quote = React.lazy(() => import('./components/pages/Quote'));

function App() {
  const { token } = useSelector((state) => state.auth);
  const { isLoading } = useSelector((state) => state.loading); // Access global loading state

  return (
    <div className="App">
      {isLoading && <LoadingSpinner />}
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="" element={<Layout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path='/forgot-password' element={<Forgotpassword />} />
            <Route path='/reset-password' element={<Resetpassword />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="" element={<Shop />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:id" element={<Product />} />
            {token && (
              <>
                <Route path="/quote" element={<Quote />} />
                <Route path="/account" element={<Myaccount />} />
                <Route path="/change-password" element={<Changepassword />} />
              </>
            )}
            <Route path="/about" element={<About />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/term-of-use" element={<Termofuse />} />
            <Route path="/terms-of-delivery" element={<Termofdelivary />} />
            <Route path="/privacy-policy" element={<Privacypolicy />} />
            <Route path="/refund-returns" element={<Returnrefund />} />
          </Route>
        </Routes>
      </Suspense>
      <TawkWidget />
      <GoogleAnalytics />
      {/* <PixelTracker /> */}
      <WhatsAppButton />
      <ToastContainer />
    </div>
  );
}

export default App;
